module.exports = __webpack_public_path__ + "static/img/construct4.d59c95bc.png";